import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPages.css';

const TermsOfServices = () => {
  return (
    <div className="policy-page">
      {/* Hero Banner */}
      <section className="policy-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h1>Terms of Services</h1>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <figure className="policy-image">
                <img src="/assets/images/data-protection.svg" alt="Terms of Services" />
              </figure>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="policy-content">
        <div className="container">
          <div className="policy-content-inner">
            <p>
              <strong>Last Updated:</strong> September 20, 2022
            </p>

            <p>
              Your use of <Link to="/">www.Dive-in Panels.com</Link> and Dive-in Panels (henceforth "Dive-in Panels")
              Online Service and Products (referred to as the offering in this document as the "Offering" and excluding
              any offering provided to you by Dive-in Panels under a separate written agreement) is subject to these terms,
              without prejudice to any additional terms which may be part of an agreement specific to the service you wish
              to avail of. Your agreement with Dive-in Panels will always include at a minimum, the terms and conditions
              set out in this document.
            </p>

            <p>
              Dive-in Panels (together with any affiliates, "we", "us", "our'' and the "Company") owns and operates one
              or more websites, mobile apps, and interactive services, under the brand Dive-in Panels or associated brands
              (collectively, the "Platform"). These Terms of Use ("Terms") apply to the Platform and to all of the features,
              mobile applications, emails, online services and other functionalities (collectively, the "Features") available
              via or related to the Platform, whether accessed via a computer, mobile device, or otherwise.
            </p>

            <p>
              These Terms are a legal agreement between you and the Company. By using the Platform or our Services (defined below),
              or by agreeing to these Terms where that option is made available to you, you agree to be bound by these Terms as well
              as our <Link to="/privacy-policy">Privacy Policy</Link>. If you do not agree to these Terms or our Privacy Policy,
              please do not register with our Platform or our Services.
            </p>

            <h3>Accepting the Terms</h3>
            <p>
              Dive-in Panels shall interact with its Users through its Website and/or mobile application named "Dive-in Panels"
              (hereinafter cumulatively referred to as "Platform"). By clicking a button or checkbox on a website, you accept
              and agree to the terms, where this option is made available to you by Dive-in Panels in the User interface for any Offering.
            </p>

            <p>
              At Dive-in Panels, we value legal activities, compliances and the word of the Law. We take our legal obligations
              seriously and hence, mandate that in order to use the Offering, you must first agree to the terms. You may not use
              the Offering if you do not accept the terms. Your use of our Offering in any manner is a deemed acceptance of each
              of the terms mentioned herein and other Policies or terms mentioned. If you require any assistance using our services
              please contact us at help@trackopinion.com
            </p>

            <h3>Eligibility</h3>
            <p>
              <strong>The Website And Services Are Intended Solely For Persons Who Can Form Legally Binding Contracts Under
              Indian Law And Who Are 18 Years Of Age Or Older</strong> or by Duly incorporated or authorised entities and their
              authorised individuals/representatives. A User Represents And Warrants That He Has Full Power And Authority For
              Using The Services And Is In Strict Compliance Of All Laws.
            </p>

            <h3>Registration</h3>
            <p>
              In order to avail our Offering, You must be registered on Our Platform. In order to use our Offering, You must
              provide us with all such information as may be required and is sought by you in a due manner. The User shall ensure
              that all such information provided to us shall be authentic, reliable, updated and relevant.
            </p>

            <p>
              The User shall also ensure that all details provided during or for registration shall be true and correct and shall
              not make any misrepresentations or state wrong facts, etc. for such registration. By registering with Us, You agree
              to provide true, accurate, current and complete information failing which We may at any time reject User's Registration
              And Terminate their Right To Use Or Access The Website And/Or Offering. When User Registers With Us, A User Account
              Will Be Created, That Is Associated With User's User Name, Password And Other Identifying Information. User Shall Be
              Responsible For Anything That Happens Through their User Account.
            </p>

            <h3>Use of the Platform</h3>
            <p>
              Subject to all of the provisions of these Terms, the Company hereby grants you a limited, terminable, non-transferable,
              personal, non-exclusive license to access and use the Platform and our Services solely as provided herein. You may
              download material displayed on the Website for non-commercial, personal use only, provided you do not remove any
              copyright and other proprietary notices contained on the materials.
            </p>

            <h3>User Conduct</h3>
            <p>You agree not to:</p>
            <ul className="policy-list">
              <li>Use the Platform for any unlawful purpose or in violation of these Terms</li>
              <li>Attempt to gain unauthorized access to any portion of the Platform</li>
              <li>Interfere with or disrupt the Platform or servers or networks connected to the Platform</li>
              <li>Use any robot, spider, scraper, or other automated means to access the Platform</li>
              <li>Impersonate any person or entity or falsely state or misrepresent your affiliation with any person or entity</li>
              <li>Provide false, misleading, or inaccurate information in surveys or registration</li>
              <li>Create multiple accounts to participate in surveys more than once</li>
              <li>Share or sell your account credentials to others</li>
            </ul>

            <h3>Points and Rewards</h3>
            <p>
              Users can earn points by completing surveys and participating in research activities. Points can be redeemed for
              rewards as specified on the Platform. The Company reserves the right to modify the point system, rewards, and
              redemption policies at any time. Points have no cash value and cannot be transferred to other users.
            </p>

            <p>
              The Company reserves the right to suspend or terminate accounts and forfeit points if fraudulent activity is detected,
              including but not limited to providing false information, creating multiple accounts, or using automated tools to
              complete surveys.
            </p>

            <h3>Intellectual Property Rights</h3>
            <p>
              The Platform and all materials therein or transferred thereby, including, without limitation, software, images, text,
              graphics, logos, patents, trademarks, service marks, copyrights, photographs, audio, videos, music and all Intellectual
              Property Rights related thereto, are the exclusive property of Dive-in Panels.
            </p>

            <h3>Limitation of Liability</h3>
            <p>
              To the maximum extent permitted by applicable law, in no event shall Dive-in Panels or its suppliers be liable for
              any special, incidental, indirect, or consequential damages whatsoever arising out of or in connection with your access
              or use or inability to access or use the Platform.
            </p>

            <h3>Indemnification</h3>
            <p>
              You agree to indemnify, defend and hold harmless Dive-in Panels and its officers, directors, employees, agents,
              affiliates, successors, and assigns from and against any and all losses, damages, liabilities, deficiencies, claims,
              actions, judgments, settlements, interest, awards, penalties, fines, costs, or expenses of whatever kind, including
              reasonable attorneys' fees, arising from or relating to your use or misuse of the Platform or your breach of these Terms.
            </p>

            <h3>Termination</h3>
            <p>
              The Company may terminate or suspend your access to the Platform immediately, without prior notice or liability, for
              any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the
              Platform will immediately cease. You may also terminate your account at any time by contacting us or deleting your
              account from the profile settings.
            </p>

            <h3>Governing Law</h3>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict
              of law provisions. Any disputes arising out of or related to these Terms shall be subject to the exclusive jurisdiction
              of the courts in Gurugram, Haryana, India.
            </p>

            <h3>Changes to Terms</h3>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material,
              we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will
              be determined at our sole discretion. By continuing to access or use our Platform after those revisions become effective,
              you agree to be bound by the revised terms.
            </p>

            <h3>Severability</h3>
            <p>
              If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted
              to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining
              provisions will continue in full force and effect.
            </p>

            <div className="contact-info">
              <h3>Contact Us</h3>
              <p>If you have any questions about these Terms of Services, please contact us:</p>
              <p><strong>Email:</strong> help@trackopinion.com</p>
              <p><strong>Address:</strong> 607-608, Tower C, Nirvana Courtyard, Sector 50, Gurugram, 122018</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfServices;

